export const staircaseConfig = {
    gameSlug: 'sound-sweeps',
    category: 'feu_vivacite',
    variable: 'duration_ms',
    startValue: 250,
    minValue: 25,
    maxValue: 800,
    stepSizesByPhase: [40, 20, 10, 5],
    reversalsToConverge: 4,
    reversalsForThreshold: 3,
    maxTrials: 24,
    direction: 'down-easier',
};
export const SWEEP_DIRECTIONS = ['up', 'down'];
function buildVariant(level) {
    if (level <= 10) {
        return { level, fmOctaves: 1.0, centerHz: 1000, label: 'Sweep large' };
    }
    if (level <= 20) {
        return { level, fmOctaves: 0.5, centerHz: 1000, label: 'Sweep moyen' };
    }
    if (level <= 30) {
        return { level, fmOctaves: 0.25, centerHz: 1500, label: 'Sweep fin' };
    }
    if (level <= 40) {
        return { level, fmOctaves: 0.125, centerHz: 2000, label: 'Discrimination fine' };
    }
    return { level, fmOctaves: 0.0625, centerHz: 2500, label: 'Limite cortex auditif' };
}
export const levels = Array.from({ length: 50 }, (_, i) => buildVariant(i + 1));
export function variantForLevel(level) {
    const idx = Math.max(1, Math.min(50, level)) - 1;
    return levels[idx];
}
export const timing = {
    preStimulusMs: 600,
    postStimulusMs: 200,
    feedbackMs: 600,
    itiMs: 700,
    minRenderMs: 25,
};
export const paradigmMeta = {
    slug: 'sound-sweeps',
    paradigm: 'FM sweep direction discrimination (Tallal 1996, Merzenich 1996)',
    masterMage: 'Embra (vivacité-feu)',
    category: 'feu_vivacite',
    goal: 'Résolution temporelle auditive — parole rapide, prosodie, transitions phonémiques.',
};
//# sourceMappingURL=params.js.map